import {
  StandardMemberAttributesDto,
  UserDto,
} from '@act/shared/data-transfer-objects';
import { CollapsibleCard, IconLibrary } from '@act/storybook';
import { Typography } from '@mui/material';
import { Fragment } from 'react';
import { LabeledDatum } from 'toolkit/styles/dataDisplay';
import InsurancePlanEntry from './InsurancePlanEntry';
import { getClientFeedDataForSection } from './getClientFeedData';
import { areAttributesEmpty } from './areAttributesEmpty';

export interface InsuranceInformationCardProps {
  member: UserDto;
  attributes: Pick<
    StandardMemberAttributesDto,
    | 'dsnpFlag'
    | 'effectiveDate'
    | 'insurancePlanName'
    | 'medicaidId'
    | 'medicareId'
    | 'subscriberId'
    | 'clientFeedData'
  >;
  defaultClosed?: boolean;
  onToggle?: () => void;
}

const InsuranceInformationCard = ({
  member,
  attributes,
  defaultClosed = false,
  onToggle,
}) => {
  const insuranceInformationIsEmpty = areAttributesEmpty(attributes, [
    'dsnpFlag',
    'effectiveDate',
    'insurancePlanName',
    'subscriberId',
    'medicareId',
    'medicaidId',
  ]);

  const clientFeedData = getClientFeedDataForSection(
    attributes?.clientFeedData,
    'insurance'
  );

  return (
    <CollapsibleCard
      title="Insurance information"
      avatar={<IconLibrary iconName="ShieldPlus" size={24} />}
      twoColumn
      defaultClosed={defaultClosed}
      onToggle={onToggle}
    >
      {insuranceInformationIsEmpty && !clientFeedData?.length && (
        <Typography variant="bodyMedium">
          No insurance information to show.
        </Typography>
      )}
      {attributes?.insurancePlanName && (
        <InsurancePlanEntry
          clientUserId={member.clientUserId}
          dsnpFlag={attributes.dsnpFlag}
          effectiveDate={attributes.effectiveDate}
          insurancePlanName={attributes.insurancePlanName}
        />
      )}
      {attributes?.subscriberId && (
        <LabeledDatum label="Subscriber ID" datum={attributes?.subscriberId} />
      )}
      {attributes?.medicareId && (
        <LabeledDatum label="Medicare ID" datum={attributes?.medicareId} />
      )}
      {attributes?.medicaidId && (
        <LabeledDatum label="Medicaid ID" datum={attributes?.medicaidId} />
      )}
      {clientFeedData?.length > 0 && (
        <Fragment>
          {clientFeedData.map(data => {
            return (
              <LabeledDatum
                key={data.field_label}
                label={data.field_label}
                datum={data.field_value}
              />
            );
          })}
        </Fragment>
      )}
    </CollapsibleCard>
  );
};

export default InsuranceInformationCard;
